var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.29883,15.25C28.15137,9.7998,22.28906,6.41406,16,6.41406S3.84863,9.7998,0.70117,15.25   c-0.26855,0.46387-0.26855,1.03613,0,1.5C3.84863,22.2002,9.71094,25.58594,16,25.58594S28.15137,22.2002,31.29883,16.75   C31.56738,16.28613,31.56738,15.71387,31.29883,15.25z M16,22.58594c-4.92676,0-9.53711-2.50195-12.2373-6.58594   C6.46289,11.91602,11.07324,9.41406,16,9.41406S25.53711,11.91602,28.2373,16C25.53711,20.08398,20.92676,22.58594,16,22.58594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10.05371c-3.27832,0-5.94629,2.66797-5.94629,5.94629S12.72168,21.94629,16,21.94629S21.94629,19.27832,21.94629,16   S19.27832,10.05371,16,10.05371z M16,18.94629c-1.625,0-2.94629-1.32129-2.94629-2.94629S14.375,13.05371,16,13.05371   S18.94629,14.375,18.94629,16S17.625,18.94629,16,18.94629z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.5a1556ca1cd324f790096d3484869679.svg";
export { ForwardRef as ReactComponent };